import * as types from './actionTypes'

export const fetchModules = () => ({
    type: types.MODULES_FETCH
})

export const fetchModulesSuccess = (data) => ({
    type: types.MODULES_FETCH_SUCCESS,
    data
})

export const fetchModulesFailed = () => ({
    type: types.MODULES_FETCH_FAILED
})

export const createModule = (config) => ({
    type: types.CREATE_MODULE,
    config
})

export const createModuleSuccess = (item, data) => ({
    type: types.CREATE_MODULE_SUCCESS,
    item,
    data
})

export const createModuleFailed = () => ({
    type: types.CREATE_MODULE_FAILED
})

export const deleteModule = (id) => ({
    type: types.DELETE_MODULE,
    id
})

export const deleteModuleSuccess = (id, data) => ({
    type: types.DELETE_MODULE_SUCCESS,
    id,
    data
})

export const deleteModuleFailed = () => ({
    type: types.DELETE_MODULE_FAILED
})

export const updateModule = (config) => ({
    type: types.UPDATE_MODULE,
    config
})

export const updateModuleSuccess = (item, data) => ({
    type: types.UPDATE_MODULE_SUCCESS,
    item,
    data
})

export const updateModuleFailed = () => ({
    type: types.UPDATE_MODULE_FAILED
})

export const resetModuleNotification = () => ({
    type: types.RESET_MODULE_NOTIFICATION
})

export const createCard = (config, format) => ({
    type: types.CREATE_CARD,
    config,
    format
})

export const createCardSuccess = (data) => ({
    type: types.CREATE_CARD_SUCCESS,
    data
})

export const createCardFailed = () => ({
    type: types.CREATE_CARD_FAILED
})

export const updateCard = (config, format) => ({
    type: types.UPDATE_CARD,
    config,
    format
})

export const updateCardSuccess = (data, item) => ({
    type: types.UPDATE_CARD_SUCCESS,
    data,
    item
})

export const updateCardFailed = () => ({
    type: types.UPDATE_CARD_FAILED
})

export const deleteCard = (id) => ({
    type: types.DELETE_CARD,
    id
})

export const deleteCardSuccess = (data, id) => ({
    type: types.DELETE_CARD_SUCCESS,
    data
})

export const deleteCardFailed = () => ({
    type: types.DELETE_CARD_FAILED
})

export const changeModule = (cardId, moduleId) => ({
    type: types.CHANGE_MODULE,
    cardId,
    moduleId
})

export const getRollup = (cardId) => ({
    type: types.GET_ROLLUP,
    cardId
})

export const getRollupSuccess = (rollup, cardId) => ({
    type: types.GET_ROLLUP_SUCCESS,
    rollup,
    cardId
})

export const getRollupFailed = () => ({
    type: types.GET_ROLLUP_FAILED
})

export const fetchReorderModules = (order) => ({
    type: types.REORDER_MODULES,
    order
})

export const getSheets = (file, moduleId) => ({
    type: types.SHEETS_FETCH,
    file,
    moduleId
})

export const getSheetsSuccess = (data) => ({
    type: types.SHEETS_FETCH_SUCCESS,
    data
})

export const getSheetsFailed = () => ({
    type: types.SHEETS_FETCH_FAILED
})

export const importExcel = (multiple, file, entityId, name, moduleId) => ({
    type: types.EXCEL_FETCH,
	multiple,
    file,
    entityId,
    name,
    moduleId
})

export const importExcelSuccess = (entity, data) => ({
    type: types.EXCEL_FETCH_SUCCESS,
    entity,
	data
})

export const importExcelFailed = () => ({
    type: types.EXCEL_FETCH_FAILED
})

export const resetSheets = () => ({
    type: types.SHEETS_RESET
})

export const copyCard = (id) => ({
    type: types.COPY_CARD,
    id
})

export const copyCardSuccess = (data) => ({
    type: types.COPY_CARD_SUCCESS,
    data
})

export const copyCardFailed = () => ({
    type: types.COPY_CARD_FAILED
})

export const renameCard = (id, string, card) => ({
    type: types.RENAME_CARD_FETCH,
    id,
	string,
	card
})

export const renameCardSuccess = (data) => ({
    type: types.RENAME_CARD_SUCCESS,
	data
})

export const renameCardFailed = () => ({
    type: types.RENAME_CARD_FAILED
})
